import { getModel, isGoBack, generalKey } from './util'
export default Vue => {
  Vue.mixin({

    beforeRouteEnter (to, from, next) {
      const valid = isGoBack(to, from)
      if (valid) {
        const key = generalKey(to)
        const data = getModel(key)
        return next(vm => {
          const target = vm.$children.find(item => item.$options.componentName === 'BaseSearch')
          data && target && target.$emit('$model', data)
        })
      }
      next()
    }
  })
}
